module.exports = __webpack_public_path__ + "img/jorge.bec4892c.jpg";